import useAuthUser from "hooks/auth-user";
import { ReactNode, useEffect } from "react";
import {
    loadCookieYesScript,
    loadGoogleAnalyticsScript,
    loadLinkedInInsightTagScript,
    loadMetaPixelScript,
    loadUetTagScript,
} from "../../utils/analytics/tracking/trackingScripts";

export function UserTracker({
    children,
}: {
    children: ReactNode;
}): JSX.Element {
    const cookieYesScriptId = process.env.REACT_APP_COOKIE_YES_SCRIPT_ID ?? "";
    const [authUser] = useAuthUser();

    useEffect(() => {
        if (!authUser) {
            loadCookieYesScript(cookieYesScriptId);
            loadMetaPixelScript();
            loadGoogleAnalyticsScript();
            loadLinkedInInsightTagScript();
            loadUetTagScript();
        }
        return () => {
            const authToken = localStorage.getItem("auth_token");
            if (authToken) {
                // Using window.location ensures navigation happens even if React Router context is destroyed during unmount.
                // It also triggers a full reload, clearing tracking scripts if user is authenticated.
                window.location.href = "/home";
            } else {
                window.location.reload();
            }
        };
    }, [authUser]);

    return <>{children}</>;
}
